import FormacaoCargaView from "@/views/formacao-carga/FormacaoCargaView.vue";
import ManutFormacaoCargaView from "@/views/formacao-carga/ManutFormacaoCargaView.vue";
import PedidosLiberadosFormCarga from "@/components/formacao-carga/PedidosLiberadosFormCarga.vue";
import DetalhesFormCarga from "@/components/formacao-carga/DetalhesFormCarga.vue";
import AlterarDescricaoCarga from "@/components/formacao-carga/AlterarDescricaoCarga.vue";
import AlterarPlacaCarga from "@/components/formacao-carga/AlterarPlacaCarga.vue";
import CapacidadeCaixaFormCarga from "@/components/formacao-carga/CapacidadeCaixaFormCarga.vue";
import ConfigFormacaoCargaView from "@/views/formacao-carga/ConfigFormacaoCargaView.vue";
import ConfigHorariosCarga from "@/components/formacao-carga/ConfigHorariosCarga.vue";

export default [
  {
    path: "/formacao-carga",
    name: "Coasul - Formação de Carga",
    component: FormacaoCargaView,
    meta: {
      requiresAuth: true,
      sync: true,
      online: true,
      cod: 2681,
    },
    children: [
      {
        path: "detalhes/:id",
        component: DetalhesFormCarga,
      },
    ],
  },
  {
    path: "/formacao-carga/configuracoes",
    name: "Configurações",
    component: ConfigFormacaoCargaView,
    meta: {
      requiresAuth: true,
      sync: true,
      online: true,
      cod: 2681,
    },
    children: [{ path: "horarios", name: "Horários", component: ConfigHorariosCarga }],
  },
  {
    path: "/formacao-carga/:id",
    name: "Coasul - Formação de Carga",
    component: ManutFormacaoCargaView,
    meta: {
      requiresAuth: true,
      sync: true,
      online: true,
      cod: 2681,
    },
    children: [
      {
        path: "selecionar-pedido/:cx",
        component: PedidosLiberadosFormCarga,
      },
      {
        path: "alterar-descricao",
        component: AlterarDescricaoCarga,
      },
      {
        path: "alterar-placa",
        component: AlterarPlacaCarga,
      },
      {
        path: "capacidade/:cx",
        component: CapacidadeCaixaFormCarga,
      },
    ],
  },
];
